import { render, staticRenderFns } from "./EditeGroup.vue?vue&type=template&id=fd2ab8a2&scoped=true&"
import script from "./EditeGroup.vue?vue&type=script&lang=js&"
export * from "./EditeGroup.vue?vue&type=script&lang=js&"
import style0 from "./EditeGroup.vue?vue&type=style&index=0&id=fd2ab8a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2ab8a2",
  null
  
)

export default component.exports